module.exports = __webpack_public_path__ + "static/media/fly0025.9b45b44b.webp";